import Vue from 'vue'
import { env } from '@/methods/env'

const SIZE = 10
const getCurrentKey = (state) => `${state.w}_${state.t}`
const ENV_INDEX = {
    isProd: 'guokr-app-articles-news',
    isTest: 'guokr-app-articles-test-news'
}

const modelResult = {
    namespaced: true,
    state: {
        allArticles: {
        },
        loading: false,
        mounted: false,
        // need init info
        w: '',
        t: '',
    },
    mutations: {
        addArticles (state, newArticles) {
            state.allArticles[getCurrentKey(state)].articles = state.allArticles[getCurrentKey(state)].articles.concat(newArticles)
        },
        updateWordAndT (state, query) {
            state.w = query.w
            state.t = query.t
        },
        initArticleKey (state) {
            state.allArticles[getCurrentKey(state)] = {
                articles: [],
                total: 0,
                curPage: 0,
                totalPage: 1,
                sid: undefined
            }
        },
        updateSid (state, sid) {
            state.allArticles[getCurrentKey(state)].sid = sid
        },
        updateTotal (state, total) {
            state.allArticles[getCurrentKey(state)].total = total
            state.allArticles[getCurrentKey(state)].totalPage = Math.ceil(total / SIZE)
        },
        addCurPage (state) {
            state.allArticles[getCurrentKey(state)].curPage += 1
        },
        updateLoading (state, value) {
            state.loading = value
        },
        updateMounted (state) {
            state.mounted = true
        }
    },
    getters: {
        current (state) {
            return state.allArticles[getCurrentKey(state)]
        },
        articles (state) {
            const {
                articles = []
            } = state.allArticles[getCurrentKey(state)] || {}
            return articles
        },
        totalPage (state) {
            const {
                totalPage = 1
            } = state.allArticles[getCurrentKey(state)] || {}
            return totalPage
        },
        total (state) {
            const {
                total = 0
            } = state.allArticles[getCurrentKey(state)] || {}
            return total
        },
        curPage (state) {
            const {
                curPage = 0
            } = state.allArticles[getCurrentKey(state)] || {}
            return curPage
        },
        sid (state) {
            const {
                sid = undefined
            } = state.allArticles[getCurrentKey(state)] || {}
            return sid
        }
    },
    actions: {
        initFromStorage ({ state, commit, rootState }, query) {
            commit('updateWordAndT', query)
            if (!state.allArticles[getCurrentKey(state)] || performance.navigation.type === 1) {
                commit('initArticleKey')
            }
            commit('updateMounted')
        },
        async getArticles ({ state, commit, rootState }) {
            commit('updateLoading', true)
            try {
                const index = env.isProd ? ENV_INDEX.isProd : ENV_INDEX.isTest
                const current = state.allArticles[getCurrentKey(state)]
                const {
                    data: {
                        results: {
                            [index]: {
                                results = [],
                                total
                            } = {},
                        } = {},
                        sid,
                    }
                } = await Vue.prototype.$http.post('/idun/search/unified/default', {
                    wd: state.w,
                    size: SIZE,
                    sid: current.sid,
                    page: current.curPage + 1,
                    index: [index]
                })
                commit('addCurPage')
                commit('addArticles', results)
                commit('updateSid', sid)
                commit('updateTotal', total)
            } catch (e) {
                console.log('error', e)
            }
            commit('updateLoading', false)
        }
    }
}

export default modelResult



// WEBPACK FOOTER //
// ./src/store/result.js